export default class OfferCampaign {
  constructor($scope, OfferCampaignService, UiService, EmailService) {
    $scope.update_title = function() {
      $scope.updating_title = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        title: $scope.new_title
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.title = $scope.new_title;
          $scope.edit_title = false;
          $scope.updating_title = false;
        }
      });
    };
    
    $scope.update_title_el = function() {
      $scope.update_title_el = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        title_el: $scope.new_title_el
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.title_el = $scope.new_title_el;
          $scope.edit_title_el = false;
          $scope.updating_title_el = false;
        }
      });
    };

    $scope.update_general_text = function() {
      $scope.updating_general_text = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        general_text: $scope.new_general_text
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.general_text = $scope.new_general_text;
          $scope.edit_general_text = false;
          $scope.updating_general_text = false;
        }
      });
    };

    $scope.update_general_text_el = function() {
      $scope.updating_general_text_el = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        general_text_el: $scope.new_general_text_el
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.general_text_el = $scope.new_general_text_el;
          $scope.edit_general_text_el = false;
          $scope.updating_general_text_el = false;
        }
      });
    };

    $scope.update_supplier_text = function() {
      $scope.updating_supplier_text = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        supplier_text: $scope.new_supplier_text
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.supplier_text = $scope.new_supplier_text;
          $scope.edit_supplier_text = false;
          $scope.updating_supplier_text = false;
        }
      });
    };
    
    $scope.update_supplier_text_greeting = function() {
      $scope.updating_supplier_text_greeting = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        supplier_text_greeting: $scope.new_supplier_text_greeting
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.supplier_text_greeting = $scope.new_supplier_text_greeting;
          $scope.edit_supplier_text_greeting = false;
          $scope.updating_supplier_text_greeting = false;
        }
      });
    };

    $scope.update_supplier_text_el = function() {
      $scope.updating_supplier_text_el = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        supplier_text_el: $scope.new_supplier_text_el
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.supplier_text_el = $scope.new_supplier_text_el;
          $scope.edit_supplier_text_el = false;
          $scope.updating_supplier_text_el = false;
        }
      });
    };
    
    $scope.update_supplier_text_greeting_el = function() {
      $scope.updating_supplier_text_greeting_el = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        supplier_text_greeting_el: $scope.new_supplier_text_greeting_el
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.supplier_text_greeting_el = $scope.new_supplier_text_greeting_el;
          $scope.edit_supplier_text_greeting_el = false;
          $scope.updating_supplier_text_greeting_el = false;
        }
      });
    };

    $scope.update_supplier_text_el_per = function() {
      $scope.updating_supplier_text_el_per = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        supplier_text_el_per: $scope.new_supplier_text_el_per
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.supplier_text_el_per = $scope.new_supplier_text_el_per;
          $scope.edit_supplier_text_el_per = false;
          $scope.updating_supplier_text_el_per = false;
        }
      });
    };
    
    $scope.update_supplier_text_greeting_el_per = function() {
      $scope.updating_supplier_text_greeting_el_per = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        supplier_text_greeting_el_per: $scope.new_supplier_text_greeting_el_per
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.supplier_text_greeting_el_per = $scope.new_supplier_text_greeting_el_per;
          $scope.edit_supplier_text_greeting_el_per = false;
          $scope.updating_supplier_text_greeting_el_per = false;
        }
      });
    };

    $scope.update_sender_name = function() {
      $scope.updating_sender_name = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        sender_name: $scope.new_sender_name
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.sender_name = $scope.new_sender_name;
          $scope.edit_sender_name = false;
          $scope.updating_sender_name = false;
        }
      });
    };

    $scope.update_sender_name_el = function() {
      $scope.updating_sender_name_el = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        sender_name_el: $scope.new_sender_name_el
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.sender_name_el = $scope.new_sender_name_el;
          $scope.edit_sender_name_el = false;
          $scope.updating_sender_name_el = false;
        }
      });
    };

    $scope.update_filename_stocklist = function() {
      $scope.updating_filename_stocklist = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        filename_stocklist: $scope.new_filename_stocklist
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.filename_stocklist = data.filename_stocklist;
          $scope.edit_filename_stocklist = false;
          $scope.updating_filename_stocklist = false;
        }
      });
    };

    $scope.update_filename_stocklist_pi = function() {
      $scope.updating_filename_stocklist_pi = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        filename_stocklist_pi: $scope.new_filename_stocklist_pi
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.filename_stocklist_pi = data.filename_stocklist_pi;
          $scope.edit_filename_stocklist_pi = false;
          $scope.updating_filename_stocklist_pi = false;
        }
      });
    };

    $scope.update_related_offer = function() {
      $scope.updating_related_offer = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        related_offer_id: $scope.new_related_offer
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.related_offer_id = $scope.new_related_offer;
          $scope.edit_related_offer = false;
          $scope.updating_related_offer = false;
        }
      });
    };

    $scope.update_max_embedded_matched_rows = function() {
      $scope.updating_max_embedded_matched_rows = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        max_embedded_matched_rows: $scope.new_max_embedded_matched_rows
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.max_embedded_matched_rows = $scope.new_max_embedded_matched_rows;
          $scope.edit_max_embedded_matched_rows = false;
          $scope.updating_max_embedded_matched_rows = false;
        }
      });
    };

    $scope.update_special_notes = function() {
      $scope.updating_special_notes = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        special_notes: $scope.new_special_notes
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.special_notes = $scope.new_special_notes;
          $scope.edit_special_notes = false;
          $scope.updating_special_notes = false;
        }
      });
    };

    $scope.update_target_recipients = function() {
      $scope.updating_target_recipients = true;
      var campaign = {
        id: $scope.offer_campaign.id,
        target_recipients: $scope.new_target_recipients
      };
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success) {
          $scope.offer_campaign.target_recipients = $scope.new_target_recipients;
          $scope.edit_target_recipients = false;
          $scope.updating_target_recipients = false;
        }
      });
    };

    $scope.sender_names = EmailService.get_sender_names_en();
    $scope.sender_names_el = EmailService.get_sender_names_el();

    $scope.$watch('select_sender_name', function() {
      if ($scope.select_sender_name)
        $scope.new_sender_name = $scope.select_sender_name;
    });

    $scope.$watch('select_sender_name_el', function() {
      if ($scope.select_sender_name_el)
        $scope.new_sender_name_el = $scope.select_sender_name_el;
    });

    $scope.copy_fields = function() {
      $scope.copying_fields = true;
      OfferCampaignService.copy_text_fields($scope.similar_campaign_id, window.offer_campaign.id).success(function(data) {
        if (data.success)
          location.reload();
      });
    };

    $scope.update_offer_campaign = function(field, loader) {
      $scope[loader] = true;
      var campaign = {
        id: $scope.offer_campaign.id,
      };
      campaign[field] = $scope.offer_campaign[field];
      OfferCampaignService.update(campaign).success(function(data) {
        if (data.success)
          $scope[loader] = false;
      });
    };

    $scope.init = function() {
      $scope.tinymceOptions = UiService.tinymceOptions();
      $scope.offer_campaign = window.offer_campaign;
      $scope.current_page = 'basic_infos';
      $scope.similar_campaigns = window.similar_campaigns;
      $scope.currency_symbols = window.currency_symbols;
      if ($scope.similar_campaigns.length > 0)
        $scope.similar_campaign_id = $scope.similar_campaigns[0].id;
    };

    $scope.init();
  }
}

OfferCampaign.$inject = ['$scope', 'OfferCampaignService', 'UiService', 'EmailService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-campaign.ctrl.js